import React, { useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import { LocalizeContext } from 'react-locale-language';
import { languageOptions, setActiveLanguage } from '../../helpers/localization';
import { Globe } from 'lucide-react';
import { Button } from '../ui/button';

const LanguagePicker = () => {
  const { changeLanguage, langCode } = useContext(LocalizeContext);

  const onLanguageChange = lang => {
    changeLanguage(lang);
    setActiveLanguage(lang);
  };

  return (
    <div>
      <Button
        variant="outline"
        size="sm"
        className="rounded-full"
        onClick={() => onLanguageChange(langCode === 'Hebrew' ? 'English' : 'Hebrew')}
      >
        <Globe className="" size={12} />
        <span className="text-xs max-md:hidden">{langCode === 'Hebrew' ? 'עִברִית' : langCode}</span>{' '}
      </Button>
    </div>
  );
};

export default LanguagePicker;
